import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Button, Card, Form, Input, message, Popconfirm, Select } from "antd";
import { APIConstants } from "../../../../../../Common/APIConstants";
import {
  EditOutlined,
  DeleteOutlined, 
  QuestionCircleOutlined,
} from "@ant-design/icons";
import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";

const UserRoles = () => {
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  const [open, setOpen] = useState(false);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [refetch, setRefetch] = useState(false);
  const [roles, setRoles] = useState([]);
  const [form] = Form.useForm();
  const [updateRolesData, setUpdateRolesData] = useState(false);
  const [selectedRole,setSelectedRole]=useState(null)

//   //console.log(color);
  const { isdarkMode } = mode;
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    // form1.resetFields()
    setUpdateRolesData(false);
    setOpen(false);
  };
  const getRoles = () => {
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_GET_ROLES}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      //console.log(res);
      if (res) {
        setRoles(res);
      }
    });
  };
  useEffect(() => {
    getRoles();
  }, [refetch]);

  const handleNotification = (msg, type) => {
    message.open({
      content: `${msg}`,
      type: type,
    });
  };

  const roleCols = [
    { headerName: "Role ID", field: "roleId", width: 100,flex:1 },
    { headerName: "Roles", field: "roleName", width: 110, flex: 1 },
    // { headerName: "Created On ", field: "createdON", width: 110, flex: 1 },
    // { headerName: "Active ", field: "isActive", width: 110, flex: 1 },
    {
      headerName: "Actions",
      width: 80,
      flex: 1,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
           <span
  className="text-green-500 bg-green-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-green-400"
                        onClick={() => {
                          setOpen(true);
                          setUpdateRolesData(true);
                          // //console.log(params.data.groupID);
                          //console.log(params.data);
                          setSelectedRole(params.data)
                          
                          form.setFieldsValue({
                            roleName: params.data.roleName
                          });
                        }}
                      >
                        <EditOutlined />
                      </span>

            <Popconfirm
              title="Are you sure to delete ?"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteRoles(params.data)}
              trigger="click"
            >
              <span
  className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400">
                <DeleteOutlined />
              </span>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

   const onFinish = (values) => {
      //console.log(values);
      if (updateRolesData) {
        //console.log(values);
        updateRoles(values);
      } else {
        form.resetFields();
        //console.log(values); 
        insertRole(values);
      }
    };
  
    const insertRole = (formValues) => {
      console.log(formValues);
       const body = {
        roleName: formValues.roleName,
        applicationLevelRole:0,
      };
      const url = `${APIConstants.ELECTRICAL_INSERT_ROLES}`;
      //console.log(url);
      makeRequest({
        type: APIConstants.POST,
        url: url,
        body: body,
      }).then((res) => {
        setRefetch(!refetch);
        onClose();
        handleNotification(res?.message||"Successfully updated roles", "success");
        //console.log(res?.message);
      });
    };
    const updateRoles = (formValues) => {
      //console.log(formValues);
      //console.log(selectedRole)
      const body = {
        roleId:selectedRole.roleId,
        roleName: formValues.roleName,
        applicationLevelRole:0,
      };
      //console.log(body);
      const url = `${APIConstants.ELECTRICAL_UPDATE_ROLES}`;
      //console.log(url);
  
      makeRequest({
        type: APIConstants.PUT,
        url: url,
        body: body,
      }).then((res) => {
        setRefetch(!refetch);
        onClose();
        form.resetFields();
        setUpdateRolesData(false);
        handleNotification(res?.message|| "Successfully updated roles", "success");
        //console.log(res?.message);
      });
    };

  const deleteRoles = (formValues) => {
    //console.log(formValues);

    const body = {
      roleId: formValues.roleId,
    };

    const url = `${APIConstants.ELECTRICAL_DELETE_ROLES}`;

    //console.log(url);
    //console.log(body);

    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      body: body,
    }).then((res) => {
      //console.log(res);
      onClose();
      setRefetch(!refetch);
      handleNotification(res?.message|| "Successfully deleted role", "success");
    });
  };

  return (
    <div
      className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}
    >
      <div>
        <h2
          className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
            isdarkMode ? "text-white" : "text-black"
          }`}
        >
          Roles
        </h2>

        <div className="flex gap-4 h-[90vh]"> 
          {/*  Roles Configuration */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Role Configuration
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer()}>
                Add Roles +
              </Button>
            }
            className={`w-full rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, 
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={roles}
                columnDefs={roleCols}
                domLayout="normal"
              />
            </div>
          </Card>
        </div>
      </div>

      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form}
            name="Group-add-form"
            // className="font-bold"
            layout="horizontal"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 8,
              offset: 0,
            }}
            labelAlign="left"
            onFinish={onFinish}
          > 
            <Form.Item
              // label="Role Name"
               label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Role Name
                </span>
              }
              name="roleName"
              rules={[
                {
                  required: true,
                  message: "Please select a role name!",
                },
              ]}
            >
             <Input  className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                } placeholder="Enter a role name"/>
            </Form.Item>
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose} className="">
              Cancel
            </Button>
            <Button type="primary" onClick={() => form.submit()}>
              {updateRolesData?'Update':'Add'}
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
    </div>
  );
};

export default UserRoles;
